import React from 'react';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import Bandeau from 'brastrap/common/bandeau/Bandeau';
import ShopsSection from 'brastrap/editorial/shops-section/ShopsSection.jsx';

const messages = defineMessages({
  returnNav: { id: 'shops-landing.title', defaultMessage: 'Our shops' },
  title: { id: 'shops-section.all-our-shops', defaultMessage: 'Our shops' },
});

const ShopsSectionPage = props => {
  const {
    intl: { formatMessage },
  } = props;

  const returnNav = {
    label: formatMessage(messages.returnNav),
    url: '/shops/',
  };

  return (
    <div className="shops-section-page">
      <Bandeau title={formatMessage(messages.title)} returnNav={returnNav} />
      <div className="c-page__main">
        <ShopsSection {...props} />
      </div>
    </div>
  );
};

ShopsSectionPage.propTypes = {
  ...ShopsSection.propTypes,
  intl: intlShape,
};

export default injectIntl(ShopsSectionPage);
